import { all, fork } from 'redux-saga/effects'
import conciergeSaga from 'redux/concierge/conciergeSaga'
import dashboardSaga from 'features/Dashboard/dashboardSaga'
import employeeSaga from 'redux/employee/employeeSaga'
import employerSaga from 'redux/employer/employerSaga'
import flexSaga from 'redux/flex/flexSaga'
import transitPassSaga from 'redux/transitPass/transitPassSaga'
import incentivesSaga from 'redux/incentives/incentivesSaga'
import leaderboardsSaga from 'redux/leaderboards/leaderboardsSaga'
import mapIntelligenceSaga from 'redux/mapIntelligence/mapIntelligenceSaga'
import micromobilitySaga from 'redux/micromobility/micromobilitySaga'
import programsSaga from 'redux/programs/programsSaga'
import userSaga from 'redux/user/userSaga'
import qtfSaga from 'redux/qtf/qtfSaga'
import grhSaga from 'redux/grh/grhSaga'
import optInSaga from 'redux/optin/optInSaga'
import otpSaga from 'redux/otp/otpSaga'
import employeePlatformSaga from 'redux/employeePlatform/employeePlatformSaga'
import finchProviderSaga from 'features/Finch/finchSaga'
import applicationSaga from 'redux/application/applicationSaga'
import conciergeAISaga from 'features/Concierge-AI/conciergeAISaga'
import launchProgramsSaga from 'features/Programs/Launch/launchProgramsSaga'
import programSuccessSaga from 'features/Programs/Success/ProgramSuccessSaga'
import programEditingSaga from 'features/Programs/Editing/ProgramEditingSaga'
import onboardingSaga from 'features/Onboarding/onboardingSaga'
import routerSaga from 'shared/Router/RouterSaga'
import ssoSaga from 'features/SSO/SSOSaga'
import reimbursementsSaga from 'redux/reimbursements/reimbursementsSaga'
import bikeCatalogSaga from 'redux/bikeCatalog/bikeCatalogSaga'
import { autoEnrollSaga } from 'features/AutoEnroll'
import { autoInviteSaga } from 'features/AutoInvite'
import { apiRosterSyncSaga } from 'features/ApiRosterSync'
import autoTopupSaga from 'redux/auto-topup/autoTopupSaga'
import automatedReportingSaga from 'redux/automatedReporting/automatedReportingSaga'
import tagsSaga from 'redux/tags/tagsSaga'
import reportsSaga from 'features/Report/ReportsSaga'
import complianceSaga from 'redux/compliance/complianceSaga'

export default function* root() {
  yield all([
    fork(employerSaga),
    fork(employeeSaga),
    fork(mapIntelligenceSaga),
    fork(programsSaga),
    fork(conciergeSaga),
    fork(dashboardSaga),
    fork(incentivesSaga),
    fork(leaderboardsSaga),
    fork(micromobilitySaga),
    fork(flexSaga),
    fork(transitPassSaga),
    fork(userSaga),
    fork(qtfSaga),
    fork(grhSaga),
    fork(optInSaga),
    fork(otpSaga),
    fork(employeePlatformSaga),
    fork(finchProviderSaga),
    fork(applicationSaga),
    fork(conciergeAISaga),
    fork(launchProgramsSaga),
    fork(programSuccessSaga),
    fork(programEditingSaga),
    fork(onboardingSaga),
    fork(routerSaga),
    fork(ssoSaga),
    fork(reimbursementsSaga),
    fork(bikeCatalogSaga),
    fork(autoEnrollSaga),
    fork(autoInviteSaga),
    fork(apiRosterSyncSaga),
    fork(autoTopupSaga),
    fork(reportsSaga),
    fork(complianceSaga),
    fork(automatedReportingSaga),
    fork(tagsSaga),
  ])
}
